import axiosInstance from '../../utils/axiosInstance';
import { InventorySettings } from '../../types/settings/InventorySetting';
import { BUSINESS_INVENTORY_SETTINGS } from '../constants';

type GetInventorySettingsResponse = {
  data: InventorySettings;
};

export async function getInventorySettings() {
  const { data: setting } =
    await axiosInstance.get<GetInventorySettingsResponse>(
      BUSINESS_INVENTORY_SETTINGS
    );
  return setting;
}

export async function updateInventorySettings(
  inventorySettings: InventorySettings
) {
  const { data: setting } =
    await axiosInstance.post<GetInventorySettingsResponse>(
      BUSINESS_INVENTORY_SETTINGS,
      inventorySettings
    );
  return setting;
}
